//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('transportAreas', {
//        templateUrl: 'views/components/views/transportAreas/transportAreas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'transportAreasService', function ($stateParams, stateService, transportAreasService) {
            
//    		// #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;
            
//    		vm.model = {
//    			itemsListAreas: []
//    		};
            
//    		// #endregion LOAD PROCEDURE CALL

//            async function loadAreas() {
//                vm.model.itemsListAreas = (await transportAreasService.listAreas({ stockplace_id: stockPlaceId }));
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'transportarea':
//                        go({
//                            transportarea_keyno: '0',
//                            stockplace_id: stockPlaceId
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadAreas();
//            };

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
